import { Module } from '@nestjs/common';
import { winstonConfig } from '../common/logger/winston.config';
import { PrismaModule } from '../prisma/prisma.module';
import { MarcasController } from './marcas.controller';
import { MarcasService } from './marcas.service';

@Module({
  imports: [PrismaModule],
  controllers: [MarcasController],
  providers: [MarcasService],
  exports: [MarcasService],
})
export class MarcasModule {}
